import { Box } from 'components/layout/Box/Box'
import { t } from 'ttag'
import { useInternalState } from 'components/modules/creators/TemplatesCreator/tabs/Interviews/hooks/useInternalState'
import { Button } from 'components/shared/Button/Button'
import { Icon } from 'components/shared/Icon/Icon'
import {
  ChevronLeftIcon,
  ChevronRightIcon,
  GridIcon,
  HelpCircleIcon,
  DownloadIcon,
  LinkIcon,
  Edit3Icon,
} from 'components/shared/Icon/model'
import { StepButton } from 'components/shared/StepButton/StepButton'
import { StepProgressGroup } from 'components/shared/StepProgressGroup/StepProgressGroup'
import { useLocation } from 'hooks'
import React from 'react'
import { Link } from 'components/shared/Link/Link'
import { useDispatch, useSelector } from 'react-redux'
import { getLanguage } from 'ducks/auth'
import { InfoStats } from 'components/shared/InfoStats/InfoStats'
import { Contents as TemplatePage } from 'components/pages/InterviewTamplate/Template'
import styles from './InterviewsPreview.module.scss'
import { Content } from './Content/Content'
import { Loader } from 'components/shared/Loader/Loader'
import DownloadWord from 'components/shared/DownloadWord/DownloadWord'

export const InterviewsPreview = () => {
  const {
    payload: { id: uuid },
  } = useLocation()

  const dispatch = useDispatch()

  // re-render preview when the profile language changes.
  useSelector(getLanguage)

  const { state, handlers } = useInternalState({ uuid }, dispatch)

  const {
    activeSection,
    templateName,
    questionsCount,
    sectionsCount,
    activeStep,
    steps,
    pdf,
    isNextStepDisabled,
    isPreviousStepDisabled,
    projects,
    isFetching,
    sections,
  } = state

  const {
    handleChangeNextStep,
    handleChangePreviousStep,
    handleChangeStep,
    handleInterviewTemplateRedirect,
  } = handlers

  const { questions, title } = activeSection

  if (isFetching) {
    return <Loader isInline isFullScreen />
  }

  return (
    <Box className={styles.content} direction="column">
      <Box className={styles.wrapper} direction="column">
        <Box className={styles.mainContainer} direction="row" align="center">
          <StepButton
            ariaLabel="previous"
            icon={ChevronLeftIcon}
            onClick={handleChangePreviousStep}
            isDisabled={isPreviousStepDisabled}
          />
          <Box className={styles.innerContainer} direction="column">
            <Box className={styles.topSection}>
              <div className={styles.infoStats}>
                <InfoStats
                  label={t`Categories:`}
                  icon={GridIcon}
                  value={sectionsCount}
                />
                <InfoStats
                  label={t`Questions:`}
                  icon={HelpCircleIcon}
                  value={questionsCount}
                />
                <InfoStats
                  label={t`Connected jobs:`}
                  icon={LinkIcon}
                  iconClassName={styles.linkIcon}
                  value={
                    projects
                      .slice(0, 2)
                      .map(({ name }) => name)
                      .concat(
                        projects.length > 2 ? [`+${projects.length - 2}`] : [],
                      )
                      .join(', ') || '-'
                  }
                />
              </div>
              <div className={styles.title}>
                {templateName}{' '}
                <Icon
                  icon={Edit3Icon}
                  onClick={() => handleInterviewTemplateRedirect({ uuid })}
                  className={styles.editIcon}
                  size={19}
                />
              </div>
              <div className={styles.buttons}>
                {/*<Button
                  ariaLabel="back"
                  icon={CornerLeftUpIcon}
                  size="small"
                  variant="filled"
                  onClick={handleConfirmationConfirm}
                  className={styles.backButton}
                  isFullWidth
                />*/}
                <Link
                  icon={DownloadIcon}
                  label={t`PDF`}
                  className={styles.downloadButton}
                  filename={pdf!
                    .substring(pdf!.indexOf('interview-template'))
                    .slice(0, -1)}
                  size="small"
                  variant="text"
                  to={pdf}
                  isExternal
                />
                <DownloadWord
                  sections={sections}
                  templateName={templateName}
                  getButton={onClick => (
                    <Button
                      icon={DownloadIcon}
                      size="small"
                      color="primary"
                      variant="filled"
                      label={t`Word`}
                      className={styles.downloadButton}
                      onClick={onClick}
                      isFullWidth
                    />
                  )}
                />
              </div>
            </Box>

            <div className={styles.contents}>
              <TemplatePage
                isWordDoc
                sections={sections}
                title={templateName}
              />
            </div>

            <Box className={styles.info} align="center" justify="center">
              <StepProgressGroup
                className={styles.steps}
                size="large"
                steps={steps}
                onStep={handleChangeStep}
                {...{ activeStep }}
              />
            </Box>
            <Box className={styles.contentWrapper}>
              <Content {...{ questions, title }} />
            </Box>
          </Box>
          <StepButton
            ariaLabel="next"
            icon={ChevronRightIcon}
            onClick={handleChangeNextStep}
            isDisabled={isNextStepDisabled}
          />
        </Box>
      </Box>
    </Box>
  )
}
